import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import type { SerpsListItem } from '@xing-com/crate-jobs-domain-serps-constants';
import { isValidSalaryEstimate } from '@xing-com/crate-jobs-helpers';
import type { JobDetails } from '@xing-com/crate-jobs-helpers';

import type { ModuleVisibility } from '../types';

type ModulesVisibilityReturn = {
  visibleModules: ModuleVisibility;
};

export const useModulesVisibility = (
  jobDetails: JobDetails,
  hasMatchingData: boolean,
  linkboxes?: {
    kind: string;
    entries: SerpsListItem[];
  }[]
): ModulesVisibilityReturn => {
  const { isLoggedIn } = useLoginState();

  const { company, redirectsToThirdPartyUrl, salary, summary } = jobDetails;

  const visibleModules: ModuleVisibility = {
    Header: true,
    Linkboxes: Boolean(linkboxes && linkboxes?.length > 0) && !isLoggedIn,
    AiSummary: !!summary && !redirectsToThirdPartyUrl, // NW1 already checks isLoggedIn and paid job to return summary data
    MatchingSkills: hasMatchingData && !redirectsToThirdPartyUrl,
    Description: true,
    Salary:
      !!salary && !redirectsToThirdPartyUrl && isValidSalaryEstimate(salary),
    Company: !!company?.id && !redirectsToThirdPartyUrl,
    Contacts: !!company?.id && isLoggedIn && !redirectsToThirdPartyUrl,
    // SearchAlerts: !redirectsToThirdPartyUrl,
    SearchAlerts: false, // Temporarily disabled until we can create more meaningful alerts with CS - https://new-work.atlassian.net/browse/JSR-5214
    SimilarJobs: !redirectsToThirdPartyUrl,
  };

  return {
    visibleModules,
  };
};
